import { render, staticRenderFns } from "./EmployeeModal.vue?vue&type=template&id=a628c4de&"
import script from "./EmployeeModal.vue?vue&type=script&lang=ts&"
export * from "./EmployeeModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports